import { Video, NotebookPen, Sparkles, Award, Handshake } from "lucide-react";

const FEATURES = [
  { icon: Video, t: "Live video inside the course", d: "One-on-one video lessons with Greg built right into the lesson pages — chat, share links and follow along on the same page." },
  { icon: NotebookPen, t: "Digital worksheets & notes", d: "Keep your answers and notes for every day and teaching section. Everything saves automatically to your private profile." },
  { icon: Sparkles, t: "AI answer analysis", d: "AI reviews and compares your answers to highlight strengths, gaps and next steps — shared with you by your instructor." },
  { icon: Award, t: "Certificate of completion", d: "Earn a signed certificate with a unique ID anyone can verify on this website." },
  { icon: Handshake, t: "Potential freelance opportunities", d: "Standout students may be invited to collaborate on real freelance projects with the instructors and Greg Miceli." },
];

export function CourseFeatures({ testId = "course-features", inPerson = false }) {
  const items = inPerson ? FEATURES.filter((f) => f.icon !== Video) : FEATURES;
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-8 py-16" data-testid={testId}>
      <p className="font-mono-ui text-xs tracking-[0.3em] text-[#1A9AA8]">WHAT'S INCLUDED</p>
      <h2 className="mt-3 mb-10 text-2xl sm:text-3xl font-bold tracking-tight text-[#0B2A4A]">Course features</h2>
      <div className={`grid sm:grid-cols-2 gap-5 ${inPerson ? "lg:grid-cols-4" : "lg:grid-cols-5"}`}>
        {items.map(({ icon: Icon, t, d }) => (
          <div key={t} className="bg-white rounded-2xl border border-[#0B2A4A]/10 p-6 flex flex-col" data-testid={`${testId}-${t.split(" ")[0].toLowerCase()}`}>
            <span className="h-11 w-11 rounded-xl bg-[#F08A3C]/10 text-[#D96F28] flex items-center justify-center"><Icon className="h-5 w-5" /></span>
            <h3 className="mt-4 font-semibold text-[#0B2A4A] leading-snug">{t}</h3>
            <p className="mt-2 text-sm text-slate-600 leading-relaxed">{d}</p>
          </div>
        ))}
      </div>
      <p className="mt-4 text-xs text-slate-500">Freelance opportunities are not guaranteed and depend on available projects and your work.</p>
    </section>
  );
}
